import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { MModalite } from '@argalis-apps/models';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModaliteService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private configService: ConfigService,
    private http: HttpClient
  ) {}

  get(): Observable<MModalite.IModalite[]> {
    return of([{ id: 1, libelle: 'presentiel' }, { id: 2, libelle: 'e-learning' }, { id: 3, libelle: 'blended' }]);
    /*// TODO CHANGE uncomment
    if (this.configService.getOptions().useTestData === true) {
      return of([{ id: 1, libelle: 'presentiel' }, { id: 2, libelle: 'e-learning' }, { id: 3, libelle: 'blended' }]);
    } else {
      // return this.http.get<MModalite.IModalite[]>(`${this.communicationConfigService.getApiUri()}/duree_formation`);
      return of([{ id: 1, libelle: 'presentiel' }, { id: 2, libelle: 'e-learning' }, { id: 3, libelle: 'blended' }]);
    }*/
  }
}
